import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "p-1 bg-gray-lp-1100 rounded-full inline-flex gap-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (opt) => {
      return (_openBlock(), _createBlock("button", {
        key: opt.value,
        type: "button",
        class: [
        'px-3 py-1.5 text-12px xxl:text-14px transition-colors rounded-full font-normal text-black-lp-300',
        _ctx.modelValue === opt.value
          ? 'bg-white text-black-lp-200 font-bold shadow-sm'
          : 'hover:bg-gray-lp-600'
      ],
        onClick: ($event: any) => (_ctx.$emit('update:modelValue', opt.value))
      }, _toDisplayString(opt.label), 11, ["onClick"]))
    }), 128))
  ]))
}